import _uniqBy from 'lodash.uniqby'
import _orderby from 'lodash.orderby'

export default {
    CHANGE_PAGE_IS_LOADING(state, payload) {
        state.pageIsLoading = payload
    },

    SET_LOADED_EVERYTHING(state) { state.loadedEverything.status = true },
    SET_LOADING_EVERYTHING(state, payload) { state.loadedEverything.working = payload },

    /*
     * payload is array of objects(posts)
    */
    STORE_LOADED_PAGES(state, payload) {

        if (payload && payload.length > 0) {
            payload.forEach(post => {
                if (!state.postsData[post.type]) state.postsData = { ...state.postsData, ...{ [post.type]: [] } };

                if (state.postsData[post.type]) {
                    // replace freshly laoded page if it is same as previous one, eg after enter password
                    state.postsData[post.type].filter((item, key) => {
                        if (post.id === item.id) { state.postsData[post.type][key] = post }
                    })
                }
                state.postsData[post.type].push(post);

                let filtered = _uniqBy(state.postsData[post.type], 'id');
                //update meta ... we're already downlaoded it so :D
                if (filtered) state.postsData[post.type] = filtered;
            })
            //filtered = _orderby(filtered, 'date', 'desc');
        }
    },
    STORE_LOADED_NAVIGATION(state, payload) {
        if (payload.navigation && payload.navigation.length > 0) {

            if (!state.navigations[payload.menuLocation]) state.navigations = { ...state.navigations, ...{ [payload.menuLocation]: [] } }

            if (state.navigations[payload.menuLocation]) state.navigations[payload.menuLocation] = payload.navigation
        }
    },
    STORE_LOADED_TAXONOMIES(state, payload) {
        if (payload) {
            Object.keys(payload).forEach(keyTax => {
                payload[keyTax].forEach(taxData => {
                    if (!state.taxonomies[keyTax]) state.taxonomies = { ...state.taxonomies, ...{ [keyTax]: [] } };
                    if (state.taxonomies[keyTax]) {
                        state.taxonomies[keyTax].filter((item, key) => {
                            if (taxData.id === item.id) state.taxonomies[keyTax][key] = taxData;
                        })
                    }
                    state.taxonomies[keyTax].push(taxData);
                    let filtered = _uniqBy(state.taxonomies[keyTax], 'id');
                    if (filtered) state.taxonomies[keyTax] = filtered;
                })
            });
        }
    },

}